import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface ILargeCourseGroupSearchResultModel {
  ids: number[];
  count: number;
  next: null | string;
  previous: null | string;
}

export type LargeCourseGroupSearchResultModel = ITypedModel<ILargeCourseGroupSearchResultModel>;

angular.module('capability-ng-academic-planner').factory(
  'ngLargeCourseGroupSearchResultModel',
  () =>
    new Model<ILargeCourseGroupSearchResultModel>({
      ids: [],
      count: 0,
      next: null,
      previous: null
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/models/large_course_group_search_result_model.ts